var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79043 9.56182C10.1547 9.56182 12.0713 7.64519 12.0713 5.28091C12.0713 2.91663 10.1547 1 7.79043 1C5.42615 1 3.50952 2.91663 3.50952 5.28091C3.50952 7.64519 5.42615 9.56182 7.79043 9.56182Z",
    stroke: "#4E81F4",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00001 15.5157C0.998878 15.2148 1.06618 14.9175 1.19685 14.6464C1.6069 13.8263 2.76324 13.3917 3.72275 13.1948C4.41475 13.0472 5.11631 12.9485 5.8222 12.8996C7.12911 12.7848 8.44356 12.7848 9.75047 12.8996C10.4563 12.9491 11.1578 13.0477 11.8499 13.1948C12.8094 13.3917 13.9658 13.7853 14.3758 14.6464C14.6386 15.199 14.6386 15.8406 14.3758 16.3932C13.9658 17.2543 12.8094 17.648 11.8499 17.8366C11.1587 17.9904 10.4569 18.0918 9.75047 18.14C8.68675 18.2302 7.61807 18.2467 6.55209 18.1892C6.30606 18.1892 6.06823 18.1892 5.8222 18.14C5.1184 18.0924 4.41927 17.991 3.73095 17.8366C2.76324 17.648 1.6151 17.2543 1.19685 16.3932C1.06685 16.119 0.999613 15.8192 1.00001 15.5157Z",
    stroke: "#4E81F4",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.1d486f7c34d713476c25bfb4626c75e9.svg";
export { ForwardRef as ReactComponent };